<template>


  <jet-dialog-modal maxWidth="2xl" :show="templatePicker === true" @close="templatePicker = false">
    <template #title>
      <div class="font-bold text-xl">
        Board Template Library
      </div>
    </template>

    <template #content>


      <div class="flex justify-end mb-4">
        <!-- Search section -->
        <div>
          <label for="search" class="sr-only">Search</label>
          <div class="relative text-gray-400 focus-within:text-gray-500">
            <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
              <!-- Heroicon name: solid/search -->
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                   aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
            <input id="search" @input="debounce(searchText($event.target.value))"
                   class="block w-full bg-white py-2 pl-10 pr-3 border border-gray-300 rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 focus:placeholder-gray-500 sm:text-sm"
                   placeholder="Search" type="search" name="search">
          </div>
        </div>
      </div>


      <!-- This example requires Tailwind CSS v2.0+ -->

      <!--          <div class="mt-2 mb-4">-->
      <!--            <button-->
      <!--                class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800">-->
      <!--              Project management-->
      <!--            </button>-->
      <!--          </div>-->


      <div class="bg-green-50 border-l-4 border-green-400 p-3 mb-2" role="alert">
        <p class="text-black font-bold">Tips:</p>
        <p class="text-gray-400 font-bold text-md">Hover on color dot for more details.</p>
      </div>
      <a-spin style="z-index: 99999;" :spinning="loadingTemplate">
        <div class="overflow-auto h-96 ">
          <div class="grid grid-cols-1 gap-4  sm:grid-cols-2">


            <div v-for="item in searchTemplates" :key="item.id"
                 @click="selectedTemplate === item ?selectedTemplate = null: selectedTemplate = item;"
                 :class="{'border-purple-500':selectedTemplate && selectedTemplate === item}"
                 class="relative rounded-lg border-2 border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-purple-500">
              <div class="flex-1 min-w-0">
                <a href="#" class="focus:outline-none">
                  <span class="absolute inset-0" aria-hidden="true" style="z-index: -1;"></span>
                  <p class="text-lg font-bold text-gray-800">
                    {{ item.name }}
                  </p>

                  <a-divider></a-divider>

                  <div class="flex flex-row space-x-4">
                    <a-tooltip :color="column.bg_color" v-for="column in item.config">
                      <template #title>
                        <div>
                          {{ column.subject }}
                        </div>
                      </template>

                      <div
                          :class="column.bg_color"
                          class="w-4 h-4 rounded-full flex items-center justify-center font-extrabold "
                      >
                      </div>
                    </a-tooltip>
                  </div>

                  <!--                    <div v-for="column in item.columns">-->
                  <!--                      {{ column.subject }}-->
                  <!--                      <div class="w-4 h-4 rounded-full" :style="{'background-color':column.color}"></div>-->
                  <!--                    </div>-->
                  <a-divider></a-divider>
                  <p class="text-sm text-yellow-500 truncate" v-if="item.is_official">
                    Official Template
                  </p>
                  <p class="text-sm text-green-500 truncate" v-if="item.team_id">
                    Team Template
                  </p>
                  <p class="text-sm text-blue-500 truncate"
                     v-if="!item.is_official && item.created_by === $page.props.user.id">
                    Personal Template (Created by you)
                  </p>
                </a>
              </div>
            </div>


          </div>
        </div>
      </a-spin>


    </template>

    <template #footer>
      <button type="button" @click="deleteTemplate()"
              v-if="selectedTemplate !=null && ($page.props.user.current_team_id === selectedTemplate.team_id || $page.props.user.id === selectedTemplate.created_by )"
              class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 mr-2 rounded"
      >
        Delete
      </button>

      <button type="button" @click="templatePicker = false;"
              class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 mr-2 rounded shadow"

      >
        Cancel
      </button>
      <button type="button" @click="applyTemplate()" v-if="selectedTemplate !=null"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"

      >
        Select
      </button>
    </template>
  </jet-dialog-modal>


  <jet-dialog-modal maxWidth="2xl" :show="flowPicker === true" @close="flowPicker = false">
    <template #title>
      <div class="font-bold text-xl">
        Retro Flow Library
      </div>
    </template>

    <template #content>


      <div class="bg-green-50 border-l-4 border-green-400 p-3 mb-2" role="alert">
        <p class="text-black font-bold">Tips:</p>
        <p class="text-gray-400 font-bold text-md">Create your own retro flow from side bar.</p>
      </div>

      <div class="overflow-auto h-96 ">
        <div class="space-y-3">
          <div v-for="flow in flowList" :key="flow.id"
               @click="selectedFlow === flow ? selectedFlow = null: selectedFlow = flow;"
               :class="{'border-purple-500':selectedFlow && selectedFlow === flow}"
               class="relative rounded-lg border-2 border-gray-300 bg-white px-6 py-5 shadow-sm flex flex-col hover:border-purple-500">
            <div class="w-full flex items-center bg-white justify-between  space-x-6">
              <div class="flex-1 truncate">
                <div class="flex justify-center space-x-3">
                  <h3 class="text-gray-900 text-lg font-bold truncate">{{ flow.name }}</h3>
                </div>
              </div>
            </div>
            <div class="flex items-center space-x-3">
              <retro-flow-wizard :current_step="flow.config.length"
                                 :flow="flow.config"></retro-flow-wizard>
            </div>
          </div>
        </div>


      </div>


    </template>

    <template #footer>
      <button type="button" @click="flowPicker = false;"
              class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 mr-2 rounded shadow"

      >
        Cancel
      </button>
      <button type="button" @click="applyFlow()" v-if="selectedFlow !=null"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"

      >
        Select
      </button>
    </template>
  </jet-dialog-modal>


  <jet-dialog-modal :show="saveTemplateModal === true" @close="saveTemplateModal = false">
    <template #title>
      Save Template
    </template>

    <template #content>


    </template>

    <template #footer>
      <button type="button" @click="saveTemplateModal = true;"
              class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 mr-2 rounded shadow"

      >
        Cancel
      </button>
      <button type="button" @click="saveTemplateModal = true;"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"

      >
        Save
      </button>
    </template>
  </jet-dialog-modal>

  <a-spin :spinning="isLoading">
    <div class="flex items-center justify-around">
      <div class="w-full">
        <div class="text-4xl font-bold text-gray-700 text-center mb-2">
          Create Your Retro Board
        </div>

        <div class="bg-green-50 border-l-4 border-green-400 p-4 mb-2" role="alert">
          <p class="text-black font-bold">Quick Tips:</p>
          <p class="text-gray-500 font-bold text-md">You can just clone your existing board with the same
            setting. </p>
        </div>


        <a-steps v-model:current="current" type="navigation">
          <a-step status="process" title="Basic Info"/>
          <a-step status="process" title="Retro Flow"/>
          <a-step status="process" title="Column Setting"/>
        </a-steps>

        <div v-if="current===0" class="mt-4">
          <label
              class="block text-lg font-bold text-gray-700"
          >Board name</label
          >
          <div class="mt-1">
            <input
                type="text"
                name="game-name"
                id="id-game-name"
                class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="Room's name"
                v-model="submitForm.name"
            />
          </div>
        </div>
        <div v-if="current===0" class="mt-4">
          <label
              class="block text-lg font-bold text-gray-700"
          >Survey Question </label
          >
          <div class="mt-1">
            <input
                type="text"
                name="game-name"
                id="survey-question"
                class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="Survey question"
                v-model="submitForm.survey_question"
            />
          </div>
        </div>

        <div v-if="current===0" class="mt-4">
          <label
              class="block text-lg font-bold text-gray-700"
          >Max Votes Per User </label
          >
          <div class="mt-1">
            <input
                type="number"
                name="game-name"
                id="max-votes"
                class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
                v-model="submitForm.max_votes"
            />
            <small>Specify how many votes a user can vote.</small>
          </div>
        </div>
        <div v-if="current===1" class="mt-4">
          <label
              class="block text-lg font-bold text-gray-700"
          >Enable Retro Flow Wizard</label>

          <div class="flex justify-between items-center">
            <div class="py-3">
              <a-switch class="mb-2 " v-model:checked="submitForm.is_wizard_enabled"></a-switch>
            </div>
            <!--            <div>-->
            <!--              <div v-if="submitForm.is_wizard_enabled" class="max-w-xl">-->
            <!--                <button-->
            <!--                    class="inline-flex justify-center w-full rounded-md border-->
            <!--                    border-blue-300 shadow-sm px-4 py-2 cursor-pointer bg-blue-400 text-md font-semibold-->
            <!--                    text-white hover:bg-blue-500 focus:outline-none focus:ring-2-->
            <!--                    focus:ring-offset-2 focus:ring-offset-blue-100 focus:ring-indigo-500"-->
            <!--                    @click="toggleShowWizard"-->
            <!--                >-->
            <!--                  {{ appliedFlow.name }}-->
            <!--                  <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5" aria-hidden="true"/>-->
            <!--                </button>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <template class="mt-1 rounde-md bg-blue-100 px-1 py-2" v-if="submitForm.is_wizard_enabled">
            <div class="mt-2 bg-blue-100">
              <div class="flex justify-center">
                <h3 class="text-gray-900 text-lg font-bold truncate">{{ appliedFlow.name }}</h3>
              </div>
              <retro-flow-wizard :current_step="appliedFlow.config.length"
                                 :flow="appliedFlow.config"></retro-flow-wizard>
              <div class="py-2 shadow-md flex justify-between">
                <!--                <button type="button" @click="saveTemplateModal = true;"-->
                <!--                        class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow "-->

                <!--                >-->
                <!--                  Save as your template-->
                <!--                </button>-->
                <button type="button" @click="openFlowSelection()"
                        class="mx-4 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                >
                  Choose from your library
                </button>
              </div>
            </div>
          </template>
        </div>
        <div v-if="current===2" class="mt-4">
          <label
              class="block text-lg font-bold text-gray-700 mb-1"
          >Columns</label
          >
          <div class="rounde-md bg-gray-100 px-4 py-5 sm:px-6 shadow-md">
            <retro-column-maker :questions="submitForm.columns" @saveTemplate="saveTemplates"></retro-column-maker>

            <div class="mt-4  flex justify-between">
              <!--                <button type="button" @click="saveTemplateModal = true;"-->
              <!--                        class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow "-->

              <!--                >-->
              <!--                  Save as your template-->
              <!--                </button>-->
              <button type="button" @click="getTemplates()"
                      class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              >
                Choose from library
              </button>
            </div>
          </div>
        </div>

        <a-divider></a-divider>
        <div class="flex" :class="current === 0 ? 'justify-end' :'justify-between '">
          <button v-if="current > 0" class="hover:bg-blue-300 px-2 font-bold text-white rounded-full  py-2 bg-blue-400"
                  style="margin-left: 8px" @click="current--;">Previous
          </button>
          <button v-if="current < 2" class="hover:bg-blue-300 px-2 font-bold text-white rounded-full  py-2 bg-blue-400"
                  @click="current++;">Next
          </button>
          <button
              v-if="current === 2"
              @click="startGame()"
              class="hover:bg-blue-300 px-2 font-bold text-white rounded-full  py-2 bg-blue-400"
          >
            {{ clickText ?? 'Start the board' }}
          </button>
        </div>

        <!--        <div v-if="current===2">-->
        <!--          <a-divider></a-divider>-->
        <!--          <div class="mt-4">-->
        <!--            <button-->
        <!--                @click="startGame()"-->
        <!--                class="p-2 bg-blue-500 hover:bg-blue-400 w-full rounded-lg shadow text-md font-bold uppercase text-white"-->
        <!--            >-->
        <!--              {{ clickText ?? 'Start the board' }}-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->

      </div>
    </div>

  </a-spin>


</template>

<script>
import {
  ref,
  computed,
  watchEffect,
  toRefs,
  defineComponent,
  reactive,
  getCurrentInstance, onMounted,
} from "vue";
import {Inertia} from "@inertiajs/inertia";
import SelectMenu from "../../Components/SelectMenu/SelectMenu";
import {message} from "ant-design-vue";
import QuestionMaker from "@/Components/QuestionMaker/QuestionMaker";
import DialogModal from "@/Jetstream/DialogModal";
import JetButton from '@/Jetstream/Button'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDialogModal from '@/Jetstream/DialogModal'
import RetroColumnMaker from "@/Components/RetroColumnMaker/RetroColumnMaker";
import RetroFlowWizard from "@/Pages/Retrospective/Components/RetroFlowWizard";
import {ChevronDownIcon} from '@heroicons/vue/solid'

export default {
  props: {
    clickText: {
      type: String,
    },
    isPublic: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isUserLoggedIn: false,
    };
  },
  emits: ['created'],
  mounted() {
  },
  methods: {
    startGame() {

    }
  },
  setup(props, context) {
    const current = ref(0);
    const saveTemplateModal = ref(false);
    const templatePicker = ref(false);
    const loadingTemplate = ref(false);
    const selectedTemplate = ref(null);
    const isLoading = ref(true);
    const showWizard = ref(false);
    const appliedFlow = ref({
      id: null,
      name: null,
      config: []
    });
    const selectedFlow = ref({
      id: null,
      name: null,
      config: []
    });
    const flowList = ref([]);
    const flowPicker = ref(false);
    const templates = ref([]);
    const searchTemplates = ref([]);
    const submitForm = reactive({
      name: null,
      is_wizard_enabled: false,
      survey_question: 'How was the sprint?',
      max_votes: 5,
      flow_id: null,
      columns: [
        {
          id: 1,
          subject: 'Start',
          color: 'green'
        },
        {
          id: 2,
          subject: 'Continue',
          color: 'blue'
        },
        {
          id: 3,
          subject: 'Stop',
          color: 'red'
        },
      ]
    });


    const startGame = () => {
      if (!submitForm.name) {
        message.error("Board name is required.");
        return;
      }
      const routeChoice = props.isPublic ? route("retrospective.create.public.board") : route("retrospective.create.team.board");
      axios
          .post(routeChoice, {
            ...submitForm
          })
          .then((response) => {
            if (response.data.success) {
              message.success("Your board is created.");
              context.emit('created');
            } else {
              message.error(response.data.message, 5);
            }
          })
          .catch((error) => {
            console.log(error);
            message.error(error.response.data.message, 5);
          });
    };

    function createDebounce() {
      let timeout = null;
      return function (fnc) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fnc();
        }, 800);
      };
    }

    const applyTemplate = () => {
      submitForm.columns = selectedTemplate.value.config;
      templatePicker.value = false;
    }

    const applyFlow = () => {
      submitForm.flow_id = selectedFlow.value.id;
      appliedFlow.value = {...selectedFlow.value}
      flowPicker.value = false;
    }
    const searchText = (key) => {
      searchTemplates.value = templates.value.filter(function (e) {
        return e.name.toLowerCase().includes(key.toLowerCase());
      });
    }

    const getFlows = () => {
      axios
          .get(route("retrospective.room.flow.get"))
          .then((response) => {
            isLoading.value = false;
            if (response.data.data.list.length > 0) {
              flowList.value = response.data.data.list
              selectedFlow.value = flowList.value[0];
              appliedFlow.value = flowList.value[0];
              submitForm.flow_id = selectedFlow.value.id;
              submitForm.is_wizard_enabled = true;
            } else {
              submitForm.is_wizard_enabled = false;
            }
          })
          .catch((error) => {
            isLoading.value = false;
            console.log(error);
            message.error('We cannot get retro flows.', 5);
          });
    }

    const openFlowSelection = () => {
      flowPicker.value = true;
    }
    const saveTemplates = (templates) => {
      if (confirm('Please confirm if you want to save your template.')) {
        isLoading.value = true;
        axios
            .post(route("retrospective.templates.save"), {template: [...templates]})
            .then((response) => {
              isLoading.value = false;
              if (response.data.success) {
                message.success(response.data.message, 5);
              } else {
                message.error(response.data.message, 5);
              }
            })
            .catch((error) => {
              isLoading.value = false;
              console.log(error);
              message.error('We cannot save templates.', 5);
            });
      }
    };

    const deleteTemplate = () => {
      if (confirm('Are you sure you want to delete it?')) {
        loadingTemplate.value = true;
        axios
            .delete(route("retrospective.templates.delete", selectedTemplate.value.id))
            .then((response) => {
              loadingTemplate.value = false;
              if (response.data.success) {
                message.success(response.data.message, 5);
              } else {
                message.error(response.data.message, 5);
              }
              selectedTemplate.value = null;
              getTemplates();
            })
            .catch((error) => {
              loadingTemplate.value = false;
              console.log(error);
              message.error('We cannot delete templates.', 5);
            });
      }
    }
    const getTemplates = () => {
      loadingTemplate.value = true;
      templatePicker.value = true;
      axios
          .get(route("retrospective.templates"))
          .then((response) => {
            loadingTemplate.value = false;
            if (response.data.success) {
              templates.value = response.data.data;
              searchTemplates.value = response.data.data;

            } else {
              message.error(response.data.message, 5);
            }
          })
          .catch((error) => {
            loadingTemplate.value = false;
            console.log(error);
            message.error('We cannot get templates.', 5);
          });
    };

    const toggleShowWizard = () => {
      showWizard.value = !showWizard.value;
    }

    onMounted(() => {
      getFlows();
    });

    return {
      saveTemplates,
      current,
      isLoading,
      appliedFlow,
      applyFlow,
      flowPicker,
      openFlowSelection,
      selectedFlow,
      getFlows,
      flowList,
      debounce: createDebounce(),
      searchText,
      applyTemplate,
      deleteTemplate,
      searchTemplates,
      selectedTemplate,
      loadingTemplate,
      getTemplates,
      templates,
      templatePicker,
      saveTemplateModal,
      submitForm,
      startGame,
      showWizard,
      toggleShowWizard
    };
  },
  components: {
    RetroFlowWizard,
    RetroColumnMaker,
    JetButton,
    JetSecondaryButton,
    JetDialogModal,
    DialogModal,
    QuestionMaker,
    SelectMenu,
    ChevronDownIcon
  },
};
</script>
